import EventBus from '@/js/util/EventBus'

import filter from '@/js/util/symbols/filter'

export default {
  name: 'BaseFilterReset',
  inject: { filter },
  props: {
    tag: {
      type: String,
      default: 'button',
    },

    checked: {
      type: Object,
      default: () => ({}),
    },

    resetType: {
      type: String,
      default: 'Single',
    },

    toggle: {
      type: Boolean,
      default: undefined,
    },
  },

  methods: {
    resetAll() {
      EventBus.$emit('reset:all')
    },
    resetSingle() {
      this.filter.$emit('reset:single', this.checked)
      const { toggle } = this
      if (toggle === undefined) {
        return
      }
      this.filter.$emit('set:modal', this.toggle)
    },
  },

  render(createElement) {
    const elementData = {
      staticClass: this.$options.name,
      on: {
        click: () => this[`reset${this.resetType}`](),
      },
    }
    return createElement(this.tag, elementData, this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/js/components/BaseFilterReset.js